import {BasicObject} from '@/types';
import {envConfig} from './env.config';
import {isAppLikeExperience} from './interface';

/** H5 迁移场景下 Web 端外跳落地页 */
export const H5_MIGRATION_EXTERNAL_GUIDE_URL = 'https://bhaulottery.in';
export const H5_MIGRATION_INVITATION_APPLY_ROUTE = 'InvitationApply';
export const H5_MIGRATION_INVITATION_APPLY_PATH = '/invitation-apply';
/** 仅正式生产 Web 走迁移重定向；UAT / 本地 / 内部预览域名均正常使用站内应用 */
const H5_MIGRATION_ENABLED_ENVS = new Set(['prod']);
const H5_MIGRATION_ALLOWED_ROUTES = new Set([
  H5_MIGRATION_INVITATION_APPLY_ROUTE,
]);

export type H5MigrationNavigationTarget =
  | {routeName: string; params?: BasicObject}
  | {externalUrl: string};
const H5_MIGRATION_APP_ENTRY_PATHS = new Set([
  H5_MIGRATION_INVITATION_APPLY_PATH,
]);

export type H5MigrationMode = 'disabled' | 'guide' | 'app';

function shouldBypassH5MigrationForHost(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname.toLowerCase();
  if (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === '[::1]' ||
    host.endsWith('.local')
  ) {
    return true;
  }
  // 连接生产 API 的内部预览域名，非对外生产站点
  if (host.includes('-pre.')) {
    return true;
  }
  return false;
}

export function isH5MigrationEnabled() {
  return (
    H5_MIGRATION_ENABLED_ENVS.has(envConfig.environment) &&
    !isAppLikeExperience() &&
    !shouldBypassH5MigrationForHost()
  );
}

export function normalizeH5MigrationPath(pathname?: string | null) {
  if (!pathname) {
    return '/';
  }
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
}

export function getH5MigrationMode(pathname?: string | null): H5MigrationMode {
  if (!isH5MigrationEnabled()) {
    return 'disabled';
  }

  const currentPath = normalizeH5MigrationPath(pathname);
  if (H5_MIGRATION_APP_ENTRY_PATHS.has(currentPath)) {
    return 'app';
  }

  return 'guide';
}

export function shouldRedirectForH5Migration(routeName?: string | null) {
  return (
    isH5MigrationEnabled() &&
    !!routeName &&
    !H5_MIGRATION_ALLOWED_ROUTES.has(routeName)
  );
}

export function getH5MigrationNavigationTarget(
  routeName: string,
  params?: BasicObject,
): H5MigrationNavigationTarget {
  if (shouldRedirectForH5Migration(routeName)) {
    return {externalUrl: H5_MIGRATION_EXTERNAL_GUIDE_URL};
  }

  return {
    routeName,
    params,
  };
}
